module.exports = __webpack_public_path__ + "assets/GoldTau.ea26d8b5587fc3bcbe983bdad07671e7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/packs1x-gold/GoldTau.png
// module id = 775
// module chunks = 0